import { EmployeeDetailsQuery_employee_teamCompanies } from '../../../../../graphql/__generated__/EmployeeDetailsQuery'

interface Props {
  teamCompany: EmployeeDetailsQuery_employee_teamCompanies
}

export const Vat = ({ teamCompany }: Props) => {
  return <>{teamCompany.vat}</>
}
